@if (background && (!image || (!imageLoaded && !_blur))) {
  @if (showPlaceholder) {
    <div class="after defaultPlaceholder"></div>
  }
}
@if (image) {
  <div
    [style.background-image]="localBackground"
    class="image"
    [style.transform]="transform"
    [style.filter]="filter"
    [style.background-size]="fit"
    [class.loaded]="imageLoaded"
  ></div>
  <!-- Note: This img is loaded transparently at 1px x 1px.
  The actual image, when loaded, will be displayed as
  the background image of the containing wrapper div.
  This allows us to conditionally replace on load. -->
  @if (image && !imageLoaded) {
    <img
      #imgEl
      [src]="imageSrc"
      (load)="setImageLoaded()"
      class="scratch"
      />
  }
}
<ng-content></ng-content>
